import apiCall from './apiCall';

const getAllApplicationOptions = async (param: any) => {
    const query = `?search=${param.search || ''}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/ApplicationOptions/GetAllApplicationOptions${query}`;
    return apiCall('get', URL);
};

const getApplicationOptionById = async (id: string) => {
    const URL = `/ApplicationOptions/GetApplicationOptionById/${id}`;
    return apiCall('get', URL);
};

const postApplicationOption = async (data: any) => {
    const URL = '/ApplicationOptions/Create';
    return apiCall('post', URL, data);
};

const putApplicationOption = async (data: any) => {
    const URL = '/ApplicationOptions/Update';
    return apiCall('post', URL, data);
};

const deleteApplicationOption = async (data: any) => {
    const URL = '/ApplicationOptions/Delete';
    return apiCall('post', URL, data);
};

export {
    getAllApplicationOptions,
    getApplicationOptionById,
    postApplicationOption,
    putApplicationOption,
    deleteApplicationOption,
};
